import { useMemo, useState } from "react";
import { Image } from 'primereact/image';
import coverlaterPdf from "./exapmles/cover-letter-example.pdf";
import shareholderPdf from "./exapmles/shareholder-consent-statement.pdf";
import signaturePdf from "./exapmles/signature-page-late-election-example.pdf";

import coverlaterPng from "./exapmles/cover-letter-example.png";
import shareholderPng from "./exapmles/shareholder-consent-statement.png";
import signaturePng from "./exapmles/signature-page-late-election-example.png";
import FilePreviewOverlay from "../../../../uiComponents/FilePreviewOverlay/FilePreviewOverlay";

type PropTypes = {
    document:Record<string, any>;
    instructions:string[];
}

function GuidForSignUpload(props:PropTypes) {

    const [showExample, setShowExample] = useState(false);
    const {
        document,
        instructions,
    } = props;

  
    const {srcPdf, srcPng} = useMemo(() => {
        if(document.documentType === "COVER_LETTER_DOCUMENT") {
            return {
                srcPdf: coverlaterPdf,
                srcPng: coverlaterPng
            }
        }
        if(document.documentType === "OFFICER_DOCUMENT") {
            return {
                srcPdf: signaturePdf,
                srcPng: signaturePng
            }
        }
        if(document.documentType === "SHAREHOLDER_DOCUMENT") {
            return {
                srcPdf: shareholderPdf,
                srcPng: shareholderPng
            }
        }
        return {
            srcPdf: "",
            srcPng: ""
        };
    }, [document]);

    return (
        <>
            <div className="flex-grow-1">
                <h2 className="mb-3">How to Sign and Upload</h2>
                <ul className="details-help m-0 p-0">
                    {
                        instructions.map(instruction => {
                            return (
                                <li className="font-medium text-lg" dangerouslySetInnerHTML={{__html: instruction}} />
                            )
                        })
                    }
                </ul>
            </div>
            <div className="flex-grow-1 cursor-pointer">
                <Image src={srcPng} alt="Image" width="200" onClick={() => setShowExample(true)}/>
            </div>

            {
                showExample ? (
                    <FilePreviewOverlay
                        preview={srcPdf}
                        closePreview={() => setShowExample(false)}
                        isLoading={false}
                        hideUploadButton
                    />
                ) : null
            }
        </>
    )
}

export default GuidForSignUpload;